const Data= [
    {
        id: 1,
        title: "Lemo_B Couture",
        coverImg: "lemo_B.png",
        url: "https://lemo-b-couture.vercel.app/",
        GitHub: "https://github.com/sirGentlejack/lemoB-couture-demo-landing-page"
    },{
        id: 2,
        title: "Investment Company",
        coverImg: "RealEstateScreenshot.png",
        url: "https://investment-two.vercel.app/",
        GitHub: "https://github.com/sirGentlejack/real-estate-website-challenge"
    }
    ,{
        id: 3,
        title: "Cirkle App",
        coverImg: "cirkleDemo.png",
        url: "https://club-party-vibes.vercel.app/",
        GitHub: "https://github.com/sirGentlejack/"
    }
    //,{
    //     id: 5,
    //     title: "Meme Creator",
    //     coverImg: "meme.png",
    //     url: "https://mem-creator.vercel.app",
    //     GitHub: "https://github.com/sirGentlejack/mem-creator"
    // },{
    //     id: 6,
    //     title: "Travel Journal",
    //     coverImg: "travelJournal.png",
    //     url: "https://travel-journal-five-rho.vercel.app/",
    //     GitHub: "https://github.com/sirGentlejack/Travel-journal"
    // },{
    //     id: 7,
    //     title: "Airbnb Demo",
    //     coverImg: "AirbnbScreenshot.png",
    //     url: "https://airbnd-demo.vercel.app/",
    //     GitHub: "https://github.com/sirGentlejack/airbnd-demo"
    // },{
    //     id: 8,
    //     title: "Flak skill A.",
    //     coverImg: "FlakScreenshot.png",
    //     url: "https://flak-official.vercel.app",
    //     GitHub: "https://github.com/sirGentlejack/flak_official"
    // }
];

export default Data